import React, { useState, useCallback, useEffect } from "react";
import FilterInput from "components/Form/filterInput";
import { Tag } from 'antd';
import { useSelector } from 'react-redux';
import { toTitleCase } from "utils/common";
import { format } from "date-fns";
import { Button } from "components/Button";

const StockHistoryFilter = ({ handleFilterDrawer, filters, handleInputChange, searchPlaceholder, handleFilterChange, loading }) => {
  const {
    userData, userDataLoading,
    uniformSizes, uniformSizesLoading
  } = useSelector((state) => state.common);

  const [appliedFilters, setAppliedFilters] = useState([]);

  const setInputValue = useCallback((key) => {
    if (filters.length) {
      let selectedValue = [...filters].find(item => item.key === key);
      return selectedValue?.value;
    } else {
      return "";
    }
  }, [filters]);

  useEffect(() => {
    if (!uniformSizesLoading && !userDataLoading) {
      let _appliedFilters = [...filters].map(item => {
        let label = "";
        let value = "";
        
        switch (item.key) {
          case "size":
            let selectedSize = [...uniformSizes].find(size => size.id === parseInt(item.value));
            value = selectedSize?.code || "";
            label = "Size";
            break;
          case "created_by":
            let selectedUser = [...userData].find(user => user.id === parseInt(item.value));
            value = selectedUser ? `${selectedUser.first_name} ${selectedUser.last_name}` : "";
            label = "Created By";
            break;
          case "stock_date":
            value = item.value ? format(new Date(item.value), "dd/MM/yyyy") : "";
            label = "Stock Date";
            break;
          case "search":
            value = toTitleCase(item.value || "");
            label = "Search term";
            break;
          default:
            label = "";
            value = "";
        }
        
        return {
          ...item,
          value,
          label
        };
      });
      
      setAppliedFilters(_appliedFilters.filter(item => item.value && item.key !== "search"));
    }
  }, [
    uniformSizes,
    userData,
    filters,
    uniformSizesLoading,
    userDataLoading
  ]);

  const handleClose = (e, item) => {
    e.preventDefault();
    if (item.key === "search") {
      handleInputChange("", item.key, true);
    } else if (item.key.includes("date")) {
      handleInputChange("", item.key, true);
    } else {
      handleFilterChange("", item.key, true);
    }
  };

  return (
    <div>
      <div className="row filter-row mb-4">
        <div className="col-10 ">
          <div className="row">
            <div className='col-sm-12 col-lg-4'>
              <FilterInput
                defaultValue={setInputValue("search")}
                onChange={e => { handleInputChange(e.target.value, "search", true) }}
                id="search"
                label={searchPlaceholder}
              />
            </div>
            <div className='col-sm-12 col-lg-8 mt-1 flex-wrap'>
              {
                appliedFilters.map(item => {
                  return (
                    <Tag 
                      icon={loading && <i className="fas fa-spinner fa-spin me-1" aria-hidden="true"></i>} 
                      className="mb-1" 
                      color={"red"} 
                      closeIcon={<i className="fa fa-times" aria-hidden="true"></i>} 
                      onClose={e => handleClose(e, item)}
                    >
                      {item?.label}
                      {item.label && " : "}
                      {item?.value}
                    </Tag>
                  );
                })
              }
            </div>
          </div>
        </div>

        <div className="col-2 d-flex justify-content-end">
          <div className="view-icons">
            <Button 
              onClick={handleFilterDrawer} 
              icon="las la-filter"
              className="list-view btn btn-link "
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default StockHistoryFilter;

